import { API } from 'aws-amplify';

export const generate = async (id: string) => API.get('ihrespezialistenBackend', `/campaigns/generate/${id}`, {});

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/campaigns', {body: one});

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/campaigns', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/campaigns/${id}`, {});

// @ts-ignore
export const readStats = (id) => API.get('ihrespezialistenBackend', `/campaigns/stats/${id}`, {});

// @ts-ignore
export const update = (one) => API.post('ihrespezialistenBackend', `/campaigns/${one.id}`, {body: one});

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/campaigns/${id}`, {});

// @ts-ignore
export const sendTest = (id, recipient) =>
  API.post('ihrespezialistenBackend', `/campaigns/sendTest/${id}`, {body: {recipient}});
